import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Response } from '../interfaces/response.interface';
import { User } from '../pages/users-management/store/models/user';
import { map } from 'rxjs/operators';
import { ApiUrlService } from './api-url.service';

@Injectable({
  providedIn: 'root',
})
export class UserPortfolioService {
  private _url = `${this._apiService.apiUrl}/access`;

  constructor(
    private _http: HttpClient,
    private _apiService: ApiUrlService,
  ) {}

  public getUserInvitations(): Observable<Response<any>> {
    return this._http.get<Response<any>>(`${this._url}/invites`);
  }

  public processInvite(inviteId: string, userLogin: string, role: string, accept = true): Observable<any> {
    const url = `${this._url}/invites/${inviteId}/${accept ? 'accept' : 'reject'}`;

    return this._http.put(url, {
      user_login: userLogin,
      role,
    });
  }

  public updateUser(userId: string, data: Partial<User>): Observable<User> {
    const url = `${this._url}/users/${userId}`;

    return this._http.put<Response<User>>(url, { ...data })
      .pipe(
        map(response => response.data),
      );
  }
}
